import { useEffect, useRef } from "react";

// Idle timeout is driven by env so infosec can audit/change it without a code change.
// REACT_APP_IDLE_TIMEOUT_MINUTES is set in .env.<environment> files.
const IDLE_TIMEOUT_MINUTES = Number(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES) || 30;

const useAutoLogout = () => {

  const logoutAfter = IDLE_TIMEOUT_MINUTES * 60 * 1000;

  const timer = useRef(null);

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      window.location.replace("/v2/user/logout");
    }, logoutAfter);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    resetTimer(); // start timer on mount

    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, []);

  return null;
};

export default useAutoLogout;